module.exports = __webpack_public_path__ + "img/navigation_ky.c6a1982b.png";